import { render, staticRenderFns } from "./merchantInfo.vue?vue&type=template&id=42923f22&scoped=true&"
import script from "./merchantInfo.vue?vue&type=script&lang=js&"
export * from "./merchantInfo.vue?vue&type=script&lang=js&"
import style0 from "./merchantInfo.vue?vue&type=style&index=0&id=42923f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42923f22",
  null
  
)

export default component.exports